// components/ConfirmationDialog.js
import Swal from 'sweetalert2';

const ConfirmationDialog = ({ title, text, icon, confirmButtonText, cancelButtonText, onConfirm }) => {
  Swal.fire({
    title,
    text,
    icon,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText,
    cancelButtonText,
    showCancelButton: true,
    customClass: {
      container: 'sweet_containerImportant',
      confirmButton: 'sweet_confirmbuttonImportant',
    },
  }).then((result) => {
    if (result.isConfirmed) {
      onConfirm();
    }
  });
};

export default ConfirmationDialog;